import { useId, type ReactNode } from 'react'
import * as LabelPrimitive from '@radix-ui/react-label'
import { cn } from '@/lib/utils'
import { Checkbox } from './checkbox'

/**
 * SettingRow — строка настройки (`.switch` макета): подпись и подсказка слева, контрол справа,
 * разделитель между строками (последняя без него). Контрол по макету — Checkbox (не тумблер).
 */
export interface SettingRowProps {
  label: string
  hint?: string
  checked?: boolean
  defaultChecked?: boolean
  onCheckedChange?: (checked: boolean) => void
  disabled?: boolean
  /** Переопределить контрол (по умолчанию — Checkbox). */
  control?: (id: string) => ReactNode
  className?: string
}

export function SettingRow({
  label,
  hint,
  checked,
  defaultChecked,
  onCheckedChange,
  disabled,
  control,
  className,
}: SettingRowProps) {
  const id = useId()
  return (
    <div
      className={cn(
        'flex items-center justify-between gap-4 border-b border-line py-3 last:border-b-0',
        className,
      )}
    >
      <div className="min-w-0">
        <LabelPrimitive.Root htmlFor={id} className="block font-medium text-txt">
          {label}
        </LabelPrimitive.Root>
        {hint ? <p className="mt-0.5 text-12 text-txt-secondary">{hint}</p> : null}
      </div>
      {control ? (
        control(id)
      ) : (
        <Checkbox
          id={id}
          checked={checked}
          defaultChecked={defaultChecked}
          onCheckedChange={(value) => onCheckedChange?.(value === true)}
          disabled={disabled}
        />
      )}
    </div>
  )
}
